import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/header.jsx";
import Main from "./components/main.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useLocalStorage from "use-local-storage";
import Footer from "./components/footer";

const App = () => {
  const defaultDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [theme, setTheme] = useLocalStorage(
    "theme",
    defaultDark ? "dark" : "light"
  );

  const handleThemeSwitch = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
  };

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  return (
    <>
      <ToastContainer className="text-sm" />
      <Header handleThemeSwitch={handleThemeSwitch} theme={theme} />
      <div className="max-w-7xl w-full m-auto xxxs:py-20 xxs:py-20 xs:py-20 sm:py-20">
        <Routes>
          <Route path="/" element={<Main theme={theme} />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default App;
